import gql from 'graphql-tag'
import { IWorkplaceGroupConnectionWithTotal } from '@api/types'
import { WorkplaceGroupTableRecordFragment } from '@api/fragments'
import client from '../../stores/apollo'

interface Payload {
  data: {
    viewer: {
      company: {
        workplaceGroups: IWorkplaceGroupConnectionWithTotal
      }
    }
  }
}

export interface IWorkplaceGroupVariables {
  first?: number
  orderBy: string
  after?: string | null
  where?: { name_contains: string }
}

export default function list(
  variables: IWorkplaceGroupVariables
): Promise<IWorkplaceGroupConnectionWithTotal> {
  return client.gql.query({ query: workplaceGroupsQuery, variables: variables }).then(
    ({
      data: {
        viewer: {
          company: { workplaceGroups },
        },
      },
    }: Payload) => workplaceGroups
  )
}

export const workplaceGroupsQuery = gql`
  query WorkplaceGroups(
    $after: String
    $orderBy: WorkplaceGroupOrderByEnum
    $first: Int
    $where: WorkplaceGroupWhereInput
  ) {
    viewer {
      company {
        workplaceGroups(first: $first, after: $after, orderBy: $orderBy, where: $where) {
          counters {
            total
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...WorkplaceGroupTableRecordFragment
            }
          }
        }
      }
    }
  }
  ${WorkplaceGroupTableRecordFragment}
`
